import { setOptions } from '@googlemaps/js-api-loader';
let googleMapsLoaderInitialized = false;
let initializedApiKey: string | null = null;
export function initializeGoogleMapsLoader(apiKey: string): void {
  if (!apiKey) {
    throw new Error(
      'Google Maps API key is required to initialize the loader.',
    );
  }
  if (googleMapsLoaderInitialized) {
    if (initializedApiKey !== apiKey) {
      console.warn(
        'Google Maps loader already initialized with a different API key; the first key will be used.',
      );
    }
    return;
  }
  setOptions({ key: apiKey, v: 'weekly' });
  initializedApiKey = apiKey;
  googleMapsLoaderInitialized = true;
}
